module.exports = __webpack_public_path__ + "img/alkim8-3.5dfb6014.svg";